module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model-validator"
  }, [_c('div', {
    staticClass: "header-area"
  }, [_c('div', {
    staticClass: "dropdown1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model1),
      expression: "model1"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.model_names), function(model) {
    return _c('option', {
      key: model,
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dropdown2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model2),
      expression: "model2"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model2 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.model_names), function(model) {
    return _c('option', {
      key: model,
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dropdown3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model3),
      expression: "model3"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.model3 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("None")]), _vm._v(" "), _vm._l((_vm.model_names), function(model) {
    return _c('option', {
      key: model,
      domProps: {
        "value": model
      }
    }, [_vm._v(_vm._s(model))])
  })], 2), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Go!"
    },
    on: {
      "click": _vm.loadResults
    }
  })])]), _vm._v(" "), (_vm.loading) ? _c('div', [_vm._v("Loading...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "results-area"
  }, _vm._l((_vm.model_results), function(result, row_number) {
    return _c('div', {
      key: result.runtime_face_uuid,
      staticClass: "results-row"
    }, [_c('div', {
      staticClass: "runtime-info-area"
    }, [_c('div', {
      staticClass: "runtime-image-area"
    }, [_c('img', {
      attrs: {
        "src": 'http://node-runner.p.owal.io:9612/faceimage/' + result.runtime_face_uuid,
        "height": "160dp"
      }
    })]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(result.camera_description) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(result.captured_at) + "\n        ")])]), _vm._v(" "), _vm._l((result.predictions), function(prediction) {
      return _c('div', {
        key: result.runtime_face_uuid + prediction.model_name,
        staticClass: "result-prediction"
      }, [(prediction.frontend_face_uuid && (prediction.match_confidence > 0.9)) ? _c('div', {
        staticClass: "image-area"
      }, [_c('img', {
        attrs: {
          "src": _vm.imageUriForFrontendFaceUUID(prediction.frontend_face_uuid)
        }
      })]) : _c('div', [(!prediction.frontend_face_uuid) ? _c('div', [_vm._v("\n              Not a face\n            ")]) : _c('div', [_vm._v("\n               \n            ")])]), _vm._v(" "), _c('div', {
        staticClass: "name-area"
      }, [_c('div', {
        style: ({
          background: _vm.colorForMatchConfidence(prediction.match_confidence)
        }),
        attrs: {
          "id": "circle"
        }
      }), _vm._v(" " + _vm._s(_vm.confidenceformat(prediction.match_confidence)) + " \n            "), _c('router-link', {
        staticClass: "potential-match-name",
        attrs: {
          "to": '/faces/' + _vm.personNameForUUID(prediction.frontend_face_uuid)
        }
      }, [_vm._v(_vm._s(_vm.personNameForUUID(prediction.frontend_face_uuid)))])], 1)])
    })], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ac00b8e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModelValidator.vue
// module id = 300
// module chunks = 1